import { Tabs } from 'antd';
import React from 'react';

import { CloseOutlined } from '@ant-design/icons';
import ModalContext from '@src/context';

import styles from './FilterContainer.less';
import CreateFilterPanel from './NewFilterPanel';
import { SAVE_FILTER_PANEL_KEY } from './constants';

export default class FilterContainer extends React.Component<any> {
  static contextType = ModalContext;

  componentDidMount() {
    const { updateActiveTab } = this.props;
    updateActiveTab('2');
  }

  render() {
    const { activeTabKey, updateActiveTab, dashboardId } = this.props;

    return (
      <div className={styles.filterContainer}>
        <CloseOutlined className={styles.closeBtn} onClick={this.onCancel} />
        <Tabs
          type="card"
          size="small"
          activeKey={activeTabKey}
          onChange={updateActiveTab}
          items={[
            {
              label: 'Create New Filter',
              key: SAVE_FILTER_PANEL_KEY,
              children: <CreateFilterPanel dashboardId={dashboardId} onCancel={this.onCancel} />,
            },
          ]}
        />
      </div>
    );
  }

  onCancel = () => {
    const { changeFilterContainerVisibility } = this.props;
    changeFilterContainerVisibility(false);
  };
}
